import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import App from './App.vue'
import router from './router'
import './styles/global.css'

const app = createApp(App)

const productionApiBase =
  window.location.hostname.endsWith('yuangan.densematrix.ai') ? 'https://api.yuangan.densematrix.ai' : ''

function reportClientError(err, info = '') {
  const payload = {
    message: err?.message || String(err || 'unknown frontend error'),
    stack: err?.stack || '',
    info,
    url: window.location.href,
    user_agent: navigator.userAgent,
  }
  fetch(`${import.meta.env.VITE_API_BASE || productionApiBase}/api/v1/internal/client-errors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {})
}

app.config.errorHandler = (err, _instance, info) => {
  reportClientError(err, info)
  console.error(err)
}

window.addEventListener('error', (event) => {
  reportClientError(event.error || event.message, 'window.error')
})

window.addEventListener('unhandledrejection', (event) => {
  reportClientError(event.reason, 'unhandledrejection')
})

app.use(createPinia())
app.use(router)
app.use(ElementPlus, { locale: zhCn })
app.mount('#app')
